// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tel-dialog .el-dialog__header,\n.tel-dialog .el-dialog__footer {\n  border: 0 !important;\n}\n.tel-dialog .el-dialog__title {\n  font-size: 16px;\n}\n.tel-dialog .el-dialog__body {\n  padding: 10px 50px;\n}\n.drawer-no-header {\n  overflow: hidden;\n}\n.drawer-no-header .el-drawer {\n    overflow: visible;\n}\n.drawer-no-header .el-drawer__header {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
